import { useCallback } from 'react'
import { useSelfEnrollment } from '../../hooks/useSelfEnrollment'
import { AlreadySelfEnrolledIndicator } from '../Buttons/AlreadySelfEnrolledIndicator'
import { SelfEnrollButton } from '../Buttons/SelfEnrollButton'
import { ShareButton } from '../Buttons/ShareButton/ShareButton'
import { StartSelfEnrollmentCourseButton } from '../Buttons/StartSelfEnrollmentCourseButton'
import styles from '../EnrolledCourseButtons/EnrolledCourseButtons.module.scss'

export const CatalogCourseButtons = ({
  startWorkflow,
  loading,
  disabled,
}: {
  startWorkflow: (isRetake?: boolean) => Promise<unknown>
  loading: boolean
  disabled: boolean
}) => {
  const { isSelfEnrolled, startCourseWithSelfEnrollment } = useSelfEnrollment()

  const handleClickSelfEnrollmentCourseButton = useCallback(() => {
    startCourseWithSelfEnrollment(startWorkflow)
  }, [startCourseWithSelfEnrollment, startWorkflow])

  return (
    <div className={styles.buttons}>
      <StartSelfEnrollmentCourseButton
        onClick={handleClickSelfEnrollmentCourseButton}
        loading={loading}
        disabled={disabled}
      />
      {isSelfEnrolled ? <AlreadySelfEnrolledIndicator /> : <SelfEnrollButton />}
      <ShareButton />
    </div>
  )
}
